import Vue from 'vue'

class InvoiceRepository {

  controller = null

  search(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/invoices/search',
        method: 'post',
        data,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  get(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/invoices/get/' + id,
        method: 'get',
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  pdf(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/invoices/pdf/' + id,
        method: 'get',
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  inlinePdf(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/invoices/pdf/' + id,
        method: 'get',
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response.data], { type: response.headers['content-type'] } );
        let url = window.URL.createObjectURL(blob);
        resolve(url)
      }).catch(async err => {
        let blob = new Blob([err.response.data], { type: err.response.headers['content-type'] } );
        err.response.data = JSON.parse(await blob.text())
        reject(err)
      })
    })
  }

  exportCsv(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/invoices/export',
        method: 'post',
        data,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  downloadAttachment(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.download({
        url: '/api/invoices/attachments/' + id,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }


  updateSageInvoiceNumber(id, sageInvoiceNumber) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/invoices/update-sage-invoice-number/' + id,
        method: 'post',
        data: {
          sageInvoiceNumber,
        }
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

    sendMail(id, type = 'invoice') {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoices/send-mail/' + id,
                method: 'get',
                data: { type },
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    mailHistory(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoices/mail-history/' + id,
                method: 'get',
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    searchByNumber(reference) {
        return new Promise((resolve, reject) => {

            if(this.controller) {
                this.controller.abort()
            }
            this.controller = new AbortController()

            Vue.auth.fetch({
                url: '/api/invoices/search-by-number',
                method: 'post',
                data: {
                    reference,
                },
                signal: this.controller.signal
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    markPaid(id, data = {}) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoices/' + id + '/mark-paid',
                method: 'post',
                data,
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    triggerPayment(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoices/' + id + '/trigger-payment',
                method: 'post',
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    importSageLettrage() {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoice/import-sage-lettrage',
                method: 'post',
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }
    cancelAndRecreate(invoiceId) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoices/cancel-and-recreate',
                method: 'post',
                data: { invoiceId },
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }
}

export default new InvoiceRepository()
